import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";

import useBLEAdvertising from "../../../../hooks/useBLEAdvertising";
import useSimplePopup from "../../../../hooks/useSimplePopup";
import useFullScreenLoading from "../../../../hooks/useFullScreenLoading";

import PrimaryButton from "../../../../components/Button/Primary";

import emergencyBluetoothIcon from "../../../../assets/img/emergency/emergency-bluetooth-icon.png";

type Props = {};
export default function AdvertisingBluetooth(props: Props) {
  const navigate = useNavigate();
  const location = useLocation();
  // 관리자인지 여부 체크 가능하게 되면 createdAdminId null 이 아니라 로직 더 추가 되어야할듯
  const { shelterId, createdAdminId, referer } = location.state || {};

  const [simpleComponent, { open }] = useSimplePopup({});
  const [result, { startBLEAdvertisingCall, stopBLEAdvertisingCall }] =
    useBLEAdvertising({ open });
  const loadingComponent = useFullScreenLoading({
    isLoading: result.isLoading ?? true,
  });

  const getStatusText = () => {
    switch (result.status) {
      case undefined:
        return "전송 요청중";
      case "START_SUCCESS":
        return "전송중";
      default:
        return;
    }
  };

  useEffect(() => {
    if (result.isLoading === false && result.status === "STOP_SUCCESS") {
      navigate(referer ?? -1);
    }
  }, [result.isLoading, result.status]);

  useEffect(() => {
    startBLEAdvertisingCall(JSON.stringify({ shelterId, createdAdminId }));
  }, []);

  return (
    <>
      {loadingComponent}
      <div className="flex flex-col justify-center h-screen">
        <div className="px-[35px]">
          <img src={emergencyBluetoothIcon} alt="emergency-bluetooth-icon" />
        </div>
        <br />
        <p className="w-full text-center font-black text-xl leading-6">
          유저들에게 관리자 정보 전송중
        </p>
        <br />
        <p className="text-base leading-[26px] text-brand-neutral-70 whitespace-pre-line text-center">
          {"Bluetooth가 켜져있는 상태로\n잠시만 대기해주세요."}
        </p>
        <div className="text-center">{getStatusText()}</div>
        <div className="fixed bottom-0 bg-white w-full h-[50px]">
          <PrimaryButton
            className="text-white h-[50px] w-full flex justify-center items-center text-base font-medium leading-[19px]"
            onClick={() => {
              stopBLEAdvertisingCall();
            }}
          >
            닫기
          </PrimaryButton>
        </div>
        {simpleComponent}
      </div>
    </>
  );
}
